import { useEffect } from 'react';
import { useSnapshot } from '../useSnapshot';
import { useStore } from '../FronteggStoreContext';
export function useProfileState() {
  return useSnapshot(useStore().store.auth.profileState);
}
export const useProfileActions = () => {
  return useStore().stateActions.auth.profileActions;
};
export const reloadProfileIfNeeded = () => {
  const {
    loading
  } = useProfileState();
  const {
    loadProfile
  } = useProfileActions();
  useEffect(() => {
    !loading && loadProfile();
  }, []);
};